import React, { useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Api from "../Api/Api.json";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Box,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useComplaintsData } from "../hooks/useComplaintsData";

let audio = null;

const ComplaintsList = ({ patient_id }) => {
  const { data, isLoading, isError, error } = useComplaintsData(patient_id);
  const [audioPath, setAudioPath] = useState("");

  const togglePlay = useCallback(
    async (item) => {
      const headers = { headers: { "Content-Type": "application/json" } };
      const requestData = {
        task: "getHealthlogSpeechPresignedURL",
        patient_id,
        date: item[0],
      };
      const res = await axios.post(
        Api.TELEDOC_PROVIDER_API,
        requestData,
        headers
      );
      const url = res.data;

      if (!audio || audioPath !== url) {
        audio = new Audio(url);
        setAudioPath(url);
      }
      await audio.play();
    },
    [patient_id, audioPath]
  );

  if (isLoading) return <Typography>Loading complaints...</Typography>;
  if (isError)
    return <Typography color="error">Error: {error.message}</Typography>;

  const [prescriptions = [], speech = []] = data;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Prescription CC Items
      </Typography>
      <List>
        {prescriptions.map(([date, cc], idx) => (
          <ListItem key={idx} divider>
            <ListItemText primary={cc} secondary={date} />
          </ListItem>
        ))}
      </List>

      <Typography variant="h5" gutterBottom sx={{ mt: 2 }}>
        Speech CC Items
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          mt: 2,
          border: 1,
          borderColor: "divider",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Table sx={{ minWidth: 650 }}>
          <TableHead sx={{ backgroundColor: "action.hover" }}>
            <TableRow>
              <TableCell>
                <strong>Date</strong>
              </TableCell>
              <TableCell>
                <strong>CC</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Play</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {speech.map((item) => (
              <TableRow key={item[0]} hover>
                <TableCell>{item[0]}</TableCell>
                <TableCell>{item[1]}</TableCell>
                <TableCell align="center">
                  <IconButton
                    aria-label="play audio"
                    onClick={() => togglePlay(item)}
                  >
                    <PlayArrowIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ComplaintsList;
